// extracted by mini-css-extract-plugin
export default {"title":"styles_title__R14cz","list":"styles_list__zGILF","list-item":"styles_list-item__6kvU3"};